<script>
/**
 * ****************************************************************************
 * @description     :   Input Radio Component
 * @created at      :   2024/05/22
 * @created by      :   ANS903 – phuongdt@ans-asia.com
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import template
 */
import template from './template.html';
import helpers from '@/utils/helpers';

/**
 * Define content of input radio component
 */
var AnsRadioButton = {
    template: template,
    props: {
        id: String,
        label: String,
        itemClass: String,
        labelClass: String,
        customizeWrapperClass: {
            type: Object,
            default: () => ({})
        },
        customizeLabelClass: {
            type: Object,
            default: () => ({})
        },
        tabindex: {
            type: Number,
            default: 1
        },
        inputClass: String,
        value: String | Number,
        modelValue: String | Number,
        isDisabled: Boolean,
        isRequired: {
            type: Boolean,
            default: false
        },
        isMobile: {
            type: Boolean,
            default: false
        },
        isHorizontal: {
            type: Boolean,
            default: false
        },
        widthLabel: {
            type: String,
            default: 'width-110-px'
        },
        inputText: {
            type: String,
            default: ''
        },
        remarks: Array,
        options: Array,
        optionScreenList: Array,
        onChange: Function,
        onChangeValue: Function
    },
    emits: ['update:modelValue', 'referOptionalInput'],
    data() {
        return {
            text: '',
            modeDisabled: false
        };
    },
    created() {
        if (!['MNG_Order001'].includes(this.$route.name)) {
            this.modeDisabled = helpers.checkAuthorityMode(this.$route.name);
        }
    },
    mounted() {
        this.text = this.inputText;
    },
    watch: {
        modelValue(val) {
            if (val) {
                if (val && val != this.optionHaveInput?.code) {
                    this.text = '';
                    this.$emit('referOptionalInput', this.text);
                }
            }
        },
        inputText(val) {
            this.text = val;
        }
    },
    computed: {
        vewValue() {
            return this.modelValue != null && this.modelValue != undefined ? this.modelValue : this.value;
        },
        checkRequired() {
            const match = this.listCode?.filter((item) => item == this.vewValue);
            return (this.addInputError || this.vewValue) && match.length;
        },
        addInputError() {
            let error = false;
            if (this.isRequired) {
                const optionSelected = this.options?.find((option) => option.code == this.modelValue);
                if (optionSelected?.input && this.text.trim() == '') {
                    error = true;
                }
            }
            return error;
        },
        optionHaveInput() {
            return this.options?.find((item) => item.input == true);
        },
        listCode() {
            return this.options?.map((item) => item.code);
        },
        wrapperClass() {
            const baseClasses = {
                'custom-div-radio': true,
                'h-30': true,
                'd-flex': this.isHorizontal,
                'gap-4': this.isHorizontal,
                'w-100': this.isHorizontal,
                required: this.isRequired && !this.vewValue
            };

            return { ...baseClasses, ...this.customizeWrapperClass };
        },
        labelDetailClass() {
            const baseClasses = {
                'form-check-label': true,
                'd-flex': true,
                'align-items-center': true
            };
            return { ...baseClasses, ...this.customizeLabelClass };
        }
    },
    methods: {
        focusSelf(e) {
            this.$nextTick(() => {
                if (e?.target && typeof e.target.focus === 'function') {
                    e.target.focus();
                }
            });
        },
        /**
         * select item and checked input radio
         * -----------------------------------------
         * @author : PhuongDT - 2024/05/22 - create
         * @params : value
         * @access : private
         */
        selectedOption(val) {
            return this.vewValue + '' == val + '';
        },
        /**
         * click update item input radio
         * -----------------------------------------
         * @author : PhuongDT - 2024/05/22 - create
         * @params : value
         * @access : private
         */
        updateInput(e) {
            const vewValue = e.target.value;
            this.$emit('update:modelValue', vewValue);
            if (this.onChange) {
                this.onChange(e, vewValue);
            }
            if (this.optionHaveInput?.code == vewValue) {
                this.$nextTick(() => {
                    var nameInput = 'input_' + e.target.id;
                    const input = document.getElementById(nameInput);
                    if (input) {
                        input.focus();
                    }
                });
            } else {
                this.focusSelf(e);
            }
        },
        /**
         * trigger event when value of radio button change
         * -----------------------------------------
         * @author : PhuongDT - 2024/05/22 - create
         * @params : event
         * @access : private
         */
        changeValue(e) {
            if (this.options.find((item) => item.input == true)?.code == e.target.value) {
                this.$nextTick(() => {
                    var nameInput = 'input_' + e.target.id;
                    const input = document.getElementById(nameInput);
                    if (input) {
                        input.focus();
                    }
                });
            } else {
                this.focusSelf(e);
            }
            if (this.onChangeValue) {
                this.onChangeValue(e, e.target.value);
            }
        },
        updateAddInput() {
            this.$emit('referOptionalInput', this.text);
        }
    }
};
export default AnsRadioButton;
</script>

<style scoped>
.ans-radio-button {
    font-size: 12px;
}
</style>
